module.exports = __webpack_public_path__ + "img/spe.b8abeeeb.png";